<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12" *ngIf="!isViewMode">
    <app-input-form-field
      formControlName="articleTitle"
      [label]="'label.article_title' | translate"
    ></app-input-form-field>
  </div>
  <div class="col-12" [ngClass]="{'view-mode': isViewMode}">
    <app-rich-text-editor
      formControlName="articleContent"
    >
    </app-rich-text-editor>
  </div>
</div>